"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionChangeState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const input_state_group_1 = require("../../components/input/input.state.group");
class CollectionChangeState {
    constructor() {
        this.startTime = Date.now();
        this.state = new input_state_group_1.IkeInputStateGroup();
        this.state.isLabelShown = false;
    }
    getState(fieldId) {
        return this.state.get(fieldId);
    }
    addState(fieldId, state) {
        state.id = fieldId;
        this.state.add(state);
    }
    get isValid() {
        return this.state.isValid;
    }
    destroy() {
        this.state.destroy();
    }
}
exports.CollectionChangeState = CollectionChangeState;
tslib_1.__decorate([
    mobx_1.computed
], CollectionChangeState.prototype, "isValid", null);
//# sourceMappingURL=collection.change.state.js.map